<template>
  <v-navigation-drawer permanent>
    <slot></slot>
    <v-list>
      <v-list-tile
        :class="activeMenu == 1 ? 'active' : 'pointer'"
        @click="$emit('changeMenu', 1)"
      >
        <!-- <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action> -->
        <v-list-tile-title>Basic Information</v-list-tile-title>
      </v-list-tile>
      <v-list-tile
        :class="activeMenu == 2 ? 'active' : 'pointer'"
        @click="$emit('changeMenu', 2)"
      >
        <v-list-tile-title>Professional Information</v-list-tile-title>
      </v-list-tile>
      <v-list-tile
        :class="activeMenu == 3 ? 'active' : 'pointer'"
        @click="$emit('changeMenu', 3)"
      >
        <v-list-tile-title>Documents</v-list-tile-title>
      </v-list-tile>
      <v-list-tile
        :class="activeMenu == 4 ? 'active' : 'pointer'"
        @click="$emit('changeMenu', 4)"
      >
        <v-list-tile-title>Bank Details</v-list-tile-title>
      </v-list-tile>
      <v-list-tile
        :class="activeMenu == 5 ? 'active' : 'pointer'"
        @click="$emit('changeMenu', 5)"
      >
        <v-list-tile-title>Other Contact Information</v-list-tile-title>
      </v-list-tile>
      <!-- <v-list-tile
        :class="activeMenu == 6 ? 'active' : 'pointer'"
        @click="$emit('changeMenu', 6)"
      >
        <v-list-tile-title>Loan History</v-list-tile-title>
      </v-list-tile> -->
    </v-list>
  </v-navigation-drawer>
</template>
<script>
  export default {
    props: ["activeMenu"],
  };
</script>
<style scoped>
  .active {
    color: #3f51b5;
  }
  .pointer {
    cursor: pointer;
  }
</style>
